export const CommonConstants = {
	sessionErrorText: 'Your session has expired. Please log in again.',
	permissionErrorText: 'You do not have permission to access this resource. Please log in again.',
	serverErrorText: 'The server is currently unavailable. Please try again later.',
	genericErrorText: 'An unexpected error occurred. Please try again later.',
	authenticationErrorText: 'Authentication failed. Please try again later.',
	invalidTrackingErrorText:
		'You have specified an invalid Tracking Number or Postcode. Please check and try again. Your Tracking Number should be 13 characters long and have a format similar to: 8ABC00001234A',
	crosOrNetworkError: 'Unable to connect to the server. Please check your connection or try again later.',
};

export const DeliveryConstants = {
	btnFaq: 'FAQ',
	welcomeText: 'Welcome to ArrowXL',
	title: 'My Delivery',
	description: 'Expecting a delivery? Find out where your parcel is',
	helpText: 'Can’t Find Your Order Details?',
	helpLinkText: 'Click Here',
	titleBooking: 'Booking your Delivery',
	descriptionBooking: 'Schedule your delivery quickly and easily.',
	helpTextBooking: 'Enter your details to get started.',
	helpLinkTarget: '#faq-section',
	trackingNumber: 'Tracking Number',
	deliveryPostcode: 'Delivery Postcode',
	trackingNumberRequired: 'Tracking Number is required',
	trackingNumberInvalid: 'Tracking Number must be 13 characters long and have a format similar to: 8ABC00001234A',
	deliveryPostcodeRequired: 'Delivery Postcode is required',
	deliveryPostcodeInvalid: 'Delivery Postcode must be 6 characters long',
	notFoundError: 'Tracking Number not found in the system',
	btnSubmit: 'SUBMIT',
	aboutTitle: 'How To Use Askaxl',
	aboutText: `To track your delivery, simply enter your tracking number and postcode into the askAXL web-app. 
           You’ll be able to see real-time updates as your item makes its way to you. 
           On the day of delivery, you’ll receive a time slot, estimated arrival time, and details of the delivery team, 
           so you’ll know exactly when to expect us. Need help? Our customer experience team is available via live chat. 
           For more ways to get in touch, see the FAQs below.`,
	aboutLinkText: 'ArrowXL – Going Beyond Delivery',
};

export const FooterConstants = {
	copyright: '© 2024 ArrowXL Limited Registered Number: 04358875 England | VAT Number: 405699277',
	arrowxlUrl: 'www.arrowxl.co.uk',
	termAndCondition: 'Terms & Conditions',
	privacyPolicy: 'Privacy Policy',
	accessibility: 'Accessibility',
};

export const FaqConstants = {
	title: 'Frequently Asked Questions',
	searchPlaceholder: 'Search for a topic or question',
};

export const TrackingConstants = {
	pageTitle: 'Tracking History',
	orderDetailsTitle: 'Order Details',
	contactDetailsTitle: 'Contact Details',
	keepingTrackTitle: 'Keeping Track',
	trackingNumber: 'Tracking Number',
	productDescription: 'Product Description',
	orderFrom: 'Order From',
	optedServices: 'Opted Services',
	activity: 'Activity',
	location: 'Location',
	noOptedService: 'No opted services',
};

export const OrderConstants = {
	orderDetails: 'Order Details',
	contactDetails: 'Contact Details',
	trackingNumber: 'Tracking Number',
	productDescription: 'Product Description',
	updateButton: 'Update Details',
	dialogMessage: 'Are you sure you want to update the details?',
	btnConfirmDetails: 'Confirm Details',
};

export const DialogConstants = {
	updateDetails: 'Update Details',
	btnNo: 'NO',
	btnYes: 'YES',
	message: 'Are you sure you want to update the details?',
};

export const DairyBookingConstants = {
	address: 'ADDRESS',
	contactInformation: 'Contact information',
	specialInstructions: 'Special Delivery Instructions',
	bookDate: 'Book a date',
	deliveryConfirmed: 'DELIVERY DATE IS CONFIRMED',
	contactDetails: 'Contact Details',
	trackingNumber: 'Tracking Number',
	email: 'Email Address',
	preferredContact: 'Preferred Contact Number',
	contactError: 'Please enter a valid UK contact number (11 digits, starting with 07).',
	mobileNumber: 'Mobile Number',
	mobileNumberRequired: 'Mobile number is required.',
	homeNumber: 'Home Number',
	workNumber: 'Work Number',
	homeAndWorkError: 'Please enter a valid UK contact number (11 digits, starting with 07).',
	addInstructions: 'Add Instructions for delivery crew',
	instructionsAdded: 'Instructions Added:',
	selectDate: 'Select a date',
	noSlotAvailable: 'No slots are available.',
	orderUpdateFailed: 'Order update failed',
	confirmDate: 'Confirm Date',
	productDescription: 'Product Description',
	orderFrom: 'Order From',
	optedServices: 'Opted Services',
	amendNote: 'You can amend your contact details below. If you need to change delivery address Please contact your retailer for advice.',
	specialDeliveryHint: 'Please add instructions for delivery crew.',
	preDeliveryHint: 'These information will be more useful to us',
	chooseDeliveryDay: 'Choose delivery day',
	chooseDeliveryDaySubtitle: 'Please select from the available dates below.',
	chooseDeliveryDayDescription:
		'The day before your delivery you will be allocated a 2 hour time window, and on the day we will provide a link to our live tracking, and we will call you 30 minutes before we arrive.',
	living: 'Where do you live?',
	rise: 'What type of rise building?',
	parking: 'Parking is available on Street?',
	vehical: 'Vehical can go inside the Street?',
	apartment: 'Apartment',
	individual: 'Individual Properties',
	flat: 'Flat',
	highRise: 'High-Rise Building',
	lowRise: 'Low-rise building',
	yes: 'Yes',
	no: 'No',
	btnCancel: 'CANCEL',
	btnBack: 'BACK',
	btnUpdate: 'UPDATE',
	btnNext: 'SUBMIT',
};
